import Vue from 'vue';
import _ from 'lodash';
import {filterApplicationsOrder} from '../../utils/helperFunctions';

const INIT_STATE = () => ({
  applications: [],
  maxLoan: 50000,
  application: {
    id: null,
    amount: 0,
    status: 'IN PROGRESS',
    stage: 1,
    loanPurpose: [{purpose: '', amount: '', differentRecipient: false, recipient: 'Borrower'}],
    brokerServiceFee: '',
    name: '',
    dob: '',
    email: '',
    mobileNumber: '',

    address: '',
    timeAtAddressYears: null,
    timeAtAddressMonths: null,
    residenceType: null,

    noPreviousAddress: false,
    previousAddress: null,
    previousTimeAtAddressYears: null,
    previousTimeAtAddressMonths: null,
    previousResidenceType: null,

    residencyStatus: '',
    driverLicenseNumber: '',
    noDriverLicense: null,

    debts: [
      {
        type: '',
        financialInstitution: '',
        jointMortgage: 'No',
        repaymentAmount: '',
        repaymentFrequency: '',
        amountOwing: '',
        limit: '',
        consolidate: false,
        undeletable: false,
      },
    ],

    additionalDocuments: [],

    additionalNotes: '',

    saveOnly: false,
    homeOwner: false,
  },
});

const state = INIT_STATE();

const getters = {
  filteredApplications: state => filterApplicationsOrder(state.applications),
};

const actions = {
  resetApplication({commit}, id = null) {
    commit({type: 'resetApplication', id});
  },
  getApplication({commit}, id) {
    return new Promise((resolve, reject) =>
      Vue.http.get('app/application', {params: {id}}).then(
        response => {
          commit({
            type: 'setApplication',
            values: response.body.application,
          });
          resolve(response);
        },
        error => {
          reject(error);
        }
      )
    );
  },
  cancelApplication({commit}, id) {
    return new Promise((resolve, reject) =>
      Vue.http
        .post('app/manage-application', {
          id,
          status: 'CANCELLED',
          saveOnly: true,
        })
        .then(
          response => {
            commit({
              type: 'upsertApplication',
              application: {
                id: response.body.application.id,
                status: response.body.application.status,
              },
            });
            return resolve(response);
          },
          error => {
            return reject(error);
          }
        )
    );
  },
  async restartApplication({commit}, id) {
    try {
      const {body} = await Vue.http.put(`app/${id}/retry`);
      commit({
        type: 'upsertApplication',
        application: {
          id: body.id,
          status: body.status,
        },
      });
      if (body) {
        console.log('Successfully retried and created new App: ', body.id)
        return body.id
      }
    } catch (e) {
      throw Error(e.message)
    }
  },
  addApplicationRepeatable({commit}, {field, structure = false}) {
    return commit({
      type: 'addApplicationRepeatable',
      field,
      structure,
    });
  },
  removeApplicationRepeatable({commit}, {field, index}) {
    return commit({
      type: 'removeApplicationRepeatable',
      field,
      index,
    });
  },
};

const mutations = {
  resetApplication(state, {id = null}) {
    state.application = {...INIT_STATE().application, id};
  },
  setApplication(state, payload) {
    state.application = Object.assign({}, payload.values);
  },
  setField(state, payload) {
    state = _.set({...state}, payload.field, payload.value);
  },
  upsertApplication(state, payload) {
    let updated = false;
    state.applications = state.applications.map(a => {
      if (a.id !== payload.application.id) {
        return a;
      }

      updated = true;
      return {
        ...a,
        ...payload.application,
      };
    });

    if (!updated) {
      state.applications.push(payload.application);
    }
  },
  addApplicationRepeatable(state, payload) {
    if (!Array.isArray(state.application[payload.field])) {
      state.application[payload.field] = [];
    }

    if (payload.structure) {
      return state.application[payload.field].push({...payload.structure});
    }

    return state.application[payload.field].push(
      _.clone(INIT_STATE().application[payload.field][0])
    );
  },
  removeApplicationRepeatable(state, payload) {
    state.application[payload.field] = state.application[payload.field]
      .slice(0)
      .filter((d, i) => i !== payload.index);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/application.js